import {
  createReqConsts,
  createActions,
  createReqWatcher,
  initialState as rootState,
  makePaginationReducer,
} from '../../../utils/redux';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

const makePharmacyReqConfig = (slug = []) => ({
  endpoint: 'pharmacies',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'mail_order',
      selector: 'mailOrder',
    },
    {
      type: 'payload.query',
      queryParameter: 'zip',
      selector: 'zip',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    ...slug,
  ],
});

const requestOptions = makePharmacyReqConfig([
  {
    type: 'payload.query',
    queryParameter: 'offset',
    selector: 'offset',
  },
]);

export const consts = createReqConsts('appointment-form', 'pharmacy-req', [
  'LOAD_MORE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'appointment-form',
  'pharmacy-req-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
  true,
);

const defaultRequestReducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'total',
});

const initialState = {
  ...rootState,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SUCCEED:
      return {
        ...state,
        succeed: true,
        sending: false,
        isLastPage: payload && !payload.length,
        list:
          state.list && state.list.length !== 0
            ? state.list.concat(payload)
            : payload,
      };

    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/pharmacy-req.js